import { render, staticRenderFns } from "./send.vue?vue&type=template&id=8a8499fa&scoped=true"
import script from "./send.vue?vue&type=script&lang=js"
export * from "./send.vue?vue&type=script&lang=js"
import style0 from "./send.vue?vue&type=style&index=0&id=8a8499fa&prod&lang=css"
import style1 from "./send.vue?vue&type=style&index=1&id=8a8499fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8499fa",
  null
  
)

export default component.exports